import { StaffInvitationResolveActions } from './staff-invitation-resolve.types';

export class StaffInvitationResolveBatchResponseDto {
  success: number;
  failed: number;
  errors: {
    message: string;
    email: string;
    originalData: StaffInvitationResolveActions;
  }[];
  succesfullyProcessed: {
    email: string;
  }[];
}
